
import { Component, Prop, Vue } from "vue-property-decorator";

import { IRouteMeta } from "@/router/interface";
import skill_routes from "@/api/routes/skills";
import structure_routes from "@/api/routes/structures";

import CStructure, { IStructureProp } from "@/components/Structure.vue";

import StructureFactory from "@/models/structure/factory";

@Component({
  name: "CSkillMentorReport",
  components: {
    CStructure
  }
})
export default class CSkillMentorReport extends Vue {
  @Prop({ required: false, default: true }) public with_btn!: boolean;

  public factories: StructureFactory[] = [];
  public factory_id: string | null = null;
  public structure: IStructureProp = {};

  public showModal() {
    this.$modal.show("download_skill_mentor_report");
  }

  public hideModal() {
    this.$modal.hide("download_skill_mentor_report");
  }

  protected async created() {
    await this.loadFactories();
  }

  private async loadFactories() {
    return this.$api
      .get(structure_routes.factories, {
        params: {
          only_my: true,
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: StructureFactory[] }) => {
        this.factories = res;
      });
  }

  public async changeStructure(structure: IStructureProp) {
    this.structure = structure;
  }

  public async downloadReport() {
    return this.$api
      .get(skill_routes.mentor_report, {
        params: {
          factory_id: this.factory_id,
          infinity_id: this.structure.infinity_id ?? null
        }
      })
      .then(res => {
        const file_link = document.createElement("a");

        file_link.href = res.data;
        file_link.setAttribute("download", `mentor_report.csv`);

        file_link.click();

        file_link.remove();
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }
}
